<template>
  <div>
    <POSPrinter
      style="display: none"
      :address="address"
      :telephone="telephone"
      :logo="logo"
      :name="name"
      :footer="footer"
      :products="invoData.products"
      :balance="invoData.balance"
      :cardPayment="invoData.cardPayment"
      :cashier="invoData.cashierName"
      :cashPayment="invoData.cashPayment"
      :chequePayment="invoData.chequePayment"
      :giftVouchers="invoData.giftVouchers"
      :discount="invoData.discount"
      :earnedLoyalityPoints="invoData.earnedLoyalityPoints"
      :grossAmount="invoData.grossAmount"
      :invoiceNo="invoData.invoiceNo"
      :loyalityPoints="invoData.loyalityPoints"
      :netAmount="invoData.netAmount"
      :otherDiscount="invoData.otherDiscount"
      :remaining="invoData.remaining"
      :tax="invoData.taxMode === 'Percentage' ? (invoData.netAmount * invoData.tax) / 100 : invoData.tax"
      :sCharge="invoData.serviceChargeMode === 'Percentage' ? (invoData.grossAmount * invoData.sCharge) / 100 : invoData.sCharge"
      :dilCharge="invoData.dilCharge"
      :totalLoyalityPoints="
        invoData.customerTotalLoyalityPoints + invoData.earnedLoyalityPoints
      "
      :customer="invoData.customerMobile"
      :customerName="invoData.customer"
      :supplierName="invoData.supplier"
      :type="printInvoType"
      :date="invoData.date"
      id="print"
    />
  </div>
</template>

<script>
import POSPrinter from "./InvoiceTemplates/POSPrinter.vue";
export default {
  name: "printInvo",
  components: { POSPrinter },
  props: ["printInvoType"],
  data() {
    return {
      address: "",
      telephone: "",
      logo: "",
      name: "",
      footer: "",
      printOnly: "",
      taxMode: "",
      serviceChargeMode: "",
      billCssFile: "../../../../static/pos.css",
      showPrintPopup: "",
      store: "",
      invoData: "",
      invoiceItem: "",
    };
  },
  watch: {
    // invoiceItem() {
    //   this.invoData = this.invoiceItem;
    // },
  },
  mounted() {
    this.$root.$on("printClicked", (store, item) => {
      this.invoData = Object.assign({}, item);
      this.store = store;
      console.log("this.stores ", this.store, item, this.invoData);
      this.updateSettings();
      if (this.invoData) {
        setTimeout(() => {
          this.PrintElem("print");
        }, 200);
      }
    });
  },
  created() {},
  methods: {
    updateSettings() {
      this.address = this.store.address;
      this.telephone = this.store.telephone;
      this.logo = this.store.logo;
      this.name = this.store.name;
      this.footer = this.store.setting.footer;
      this.printOnly = this.store.setting.printOnly;
      this.taxMode = this.store.setting.taxMode || "Percentage";
      this.serviceChargeMode = this.store.setting.serviceChargeMode || "Percentage";
      // console.log("this.shops[0].printPaperSize", this.shops[0].printSize);
      if (
        this.store.setting.printSize === "A4" ||
        this.store.setting.printSize === "A5"
      ) {
        this.billCssFile = "../../../../static/posA4.css";
      }
      if (this.store.setting.printSize === "POS Printer 58 mm Paper") {
        this.billCssFile = "../../../../static/pos.css";
        console.log("ifffffffffff this.billCssFile");
      }
      console.log(
        "this.billCssFile",
        this.store.setting.printSize,
        this.billCssFile
      );
      if (this.store.setting.printPopup) this.showPrintPopup = true;
    },

    PrintElem(elem) {
      var mywindow = window.open("", "PRINT", "fullscreen=yes");

      mywindow.document.write(
        "<html><head><title>" + document.title + "</title>"
      );

      mywindow.document.write(
        `<link rel="stylesheet" href="${this.billCssFile}" type="text/css" />`
      );
      mywindow.document.write("</head><body >");
      mywindow.document.write(document.getElementById(elem).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      if (!this.showPrintPopup) {
        mywindow.close();
      }

      return true;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/PrintInvo.vue